import '../Styles/StarplotStyles.css';
import { Component } from 'preact';

class StarplotComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      datos:[], //Datos dibujados en el starplot
      flag:1, //Flag para trasladar los puntos con respecto a los ejes del starplot una unica vez
    }
    this.update_startplot = this.update_startplot.bind(this);
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentWillReceiveProps(nextProps) {
    if(!(this.props.complete_data != nextprops.complete_data)){
      this.update_startplot(nextProps);
    }
  }

  /*
  * Método para dibujar el Starplot
  */
  update_startplot(props){
    var canvas = document.getElementById("background"),
    context = canvas.getContext("2d");

    d3.select("#container").select("svg").remove(); //remuevo el contenido

    context.strokeStyle = "rgba(0,100,160,0.24)"; //color para el foreground

    var margin = {top: 20, right: 20, bottom: 30, left: 50},
    width = canvas.width - margin.left - margin.right,
    height = canvas.height - margin.top - margin.bottom;

    context.clearRect(0,0,width,height);
    var cx = 500/2;
    var cy = 500/2;

    //modificar el tamaño del starplot
    var feature_scale = d3.scaleLinear()
    .domain([0, 100])
    .range([0, 200])
    .clamp(true);

    var line =d3.line()
    .x(d => d.x)
    .y(d => d.y)
    //.curve(d3.curveBasis)
    .context(context);

    if(this.state.flag){
      this.setState({flag:0},()=>context.translate(margin.left, margin.top));
    }

    var data=[];
    var datos = props.complete_data;
    for (let i = 0; i < datos.length; i++) {
      if(props.selected_data.includes(i)){
        data.push({
          SiO2: +datos[i].SiO2,
          TiO2: +datos[i].TiO2,
          V2O3: +datos[i].V2O3,
          Al2O3: +datos[i].Al2O3,
          Cr2O3: +datos[i].Cr2O3,
          FeO: +datos[i].FeO,
          Fe2O3: +datos[i].Fe2O3,
          MnO: +datos[i].MnO,
          MgO: +datos[i].MgO,
          NiO: +datos[i].NiO,
          ZnO: +datos[i].ZnO,
          Category1: datos[i].Category1,
        });
      }
    }

    const angleSlice = Math.PI * 2 / 11	;
    const axes = ["SiO2","TiO2","V2O5","Al2O3","Cr2O3","FeO","Fe2O3","MnO","MgO","NiO","ZnO"];

    const orientations = d3.range(axes.length).map((l, i) => i * angleSlice);
    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Laterite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    //.range(["#4D69DC","#9e0142", "#e95c47", "#fdbf6f", "#ffffbe", "#bfe5a0", "#54aead", "#5e4fa2", "#DC4DD8"])
    .range(["#7986cb","#f06292", "#ff8a65", "#ffb74d", "#fff176", "#aed581", "#4db6ac","#64b5f6", "#ba68c8"]);

    var temp;
    var color;

    data.map(l => {
      temp = axes.map((g,i) => {
        color = l.Category1;
        let radius = feature_scale(l[g]);
        let angle = angleSlice * i;
        let coord_x = cx + radius * Math.cos(angle);
        let coord_y = cy + radius * Math.sin(angle);

        return {x:coord_x, y:coord_y}
      })
      context.beginPath();
      line(temp);
      context.lineWidth = 0.5;
      context.strokeStyle = scaleColor(color);
      context.stroke();
    })

    const CONVERRSOR = l => l * (180/Math.PI)
    const brushHeight = 20
    const selections = new Map();

    var brushed = function(key, idx) {
      let selection = d3.event.selection

      if (selection === null) selections.delete(key);
      else selections.set(key, selection.map(l => feature_scale.invert(l)))

      var selected = [] //los elementos que satisfacen todos los filtros sobre los ejes

      data.map(function(d) {
        const active = Array.from(selections).every(([key, [min, max]]) => d[key] >= min && d[key] <= max);
        if (active)
        selected.push(d)
      })

      context.clearRect(0,0,width,height);
      selected.map(function(d) {
        temp = axes.map((g,i) => {

          color = d.Category1;
          let radius = feature_scale(d[g]);
          let angle = angleSlice * i;
          let coord_x = cx + radius * Math.cos(angle);
          let coord_y = cy + radius * Math.sin(angle);

          return {x:coord_x, y:coord_y}
        })

        context.beginPath();
        line(temp);
        context.lineWidth = 0.5;
        context.strokeStyle = scaleColor(color);
        context.stroke();
      })
    }

    const brush = d3.brushX()
    .extent([
      [0, -(brushHeight / 2)],
      [200, brushHeight / 2]
    ])
    .on("start brush end", brushed);


    let svg = d3.select("#container").append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")")


    svg.append("g")
    .selectAll(".axis")
    .data(axes)
    .join("g")
    .attr("transform", (d,i) => `translate(${500/2},${500/2}) rotate(${CONVERRSOR(orientations[i])})`)
    .each(function(d) { d3.select(this).call(d3.axisBottom(feature_scale).ticks([]).tickSize(0))})
    .call(brush)
    .call(g => g.append("text")
    .attr("x", 180) //modificar la ubicacion de los labels de los ejes.
    .attr("y", -5)
    .attr("text-anchor", "start")
    .attr("fill", "currentColor")
    .text(d => d))
  }


  render(){
    return (
      <div id="container" class="container-Startplot">
      <canvas id="background" width="500" height="500"></canvas>
      </div>
    );
  }

}
export default StarplotComponent;
